import { DEPRECATED_Message } from "@JohnLewisPartnership/jl-design-system/dist/components/message/Message";

export const GasInstallationUnavailableMessageUI = () => (
  <DEPRECATED_Message
    title="Gas installation is unavailable"
    body="Sorry, we're unable to offer gas removal or installation services at
    the moment. We recommend you find a local gas safe engineer to
    complete your installation."
    type="information"
    containerProps={{ ["data-component"]: "GoodToKnow" }}
  />
);
